import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup } from '@angular/forms';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { TCampaniaEspecificaViewModel } from '../../../campaniasespecificas/campaniaespecifica.types';

@Component({
    selector: 'app-documentacioncam-update',
    templateUrl: './documentacioncam-update.component.html',
    styleUrls: ['./documentacioncam-update.component.scss'],
})
export class DocumentacionCamUpdateComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() campaniaEspecifica: TCampaniaEspecificaViewModel;
    @Input() formGroup: FormGroup;
    @Input() tiposDocumentacionCam: Tc[];
    @Output() newDocumentation = new EventEmitter<any>();
    @Output() markToDelete = new EventEmitter<any>();

    isCollapsedCabecera = false;
    tipoDocumentacionCam = 0;
    obligatoria = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.campaniaEspecifica?.currentValue) {
            this.updateForm();
        }
    }

    private updateForm(): void {
        if (this.campaniaEspecifica) {
            this.formGroup.patchValue({
                IdCampaniaDescripcion: this.campaniaEspecifica?.Descripcion || '',
                AdjuntarDocumentacion: this.campaniaEspecifica?.AdjuntarDocumentacion || false,

                IdTipoDocumentacion: this.tipoDocumentacionCam || null,
                Obligatoria: this.obligatoria || false,
            });
            if (this.campaniaEspecifica?.AdjuntarDocumentacion) {
                this.form.controls['IdTipoDocumentacion'].enable();
            }
        }

        this.form = this.formGroup;
    }

    addNewDocumentation() {
        this.newDocumentation.emit({ IdTipoDocumentacion: this.form.value.IdTipoDocumentacion, Obligatoria: this.form.value.Obligatoria });
    }

    //Adjuntar Documentación
    markAllToDelete() {
        if (!this.form.value.AdjuntarDocumentacion) {
            this.form.patchValue({
                IdTipoDocumentacion: null,
                Obligatoria: false,
            });
            this.form.controls['IdTipoDocumentacion'].disable();
            this.form.controls['Obligatoria'].disable();
        } else {
            this.form.controls['IdTipoDocumentacion'].enable();
            this.form.controls['Obligatoria'].enable();
        }
        this.markToDelete.emit(this.form.value.AdjuntarDocumentacion);
    }
}
